module.exports = __webpack_public_path__ + "img/grupo-personas.bf0937b6.png";